// React Query timing constants
// These constants define standard cache and stale times for different types of data
//
// IMPORTANT: Only add new constants if they differ from the DEFAULT values.
// If a data type has the same timing as DEFAULT, use STALE_TIME.DEFAULT or CACHE_TIME.DEFAULT instead.
// This prevents unnecessary duplication and keeps the constants file clean and maintainable.

// Standard stale times (how long data is considered fresh)
export const STALE_TIME = {
  CONTEST: 30_000, // 30 seconds
  PAYMENT: 10 * 60 * 1000, // 10 minutes
  VOUCHER_CONTEST: 2 * 60 * 1000, // 2 minutes
  CMS: 10 * 60 * 1000, // 10 minutes
  QUICKPICKS: 30_000, // 30 seconds
  // Use this for: USER, VOUCHER, and other data that changes infrequently
  DEFAULT: 5 * 60 * 1000, // 5 minutes
} as const;

// Standard cache times (how long to keep data in cache after it becomes stale)
export const CACHE_TIME = {
  PAYMENT: 15 * 60 * 1000, // 15 minutes
  VOUCHER_CONTEST: 5 * 60 * 1000, // 5 minutes
  CMS: 15 * 60 * 1000, // 15 minutes
  QUICKPICKS: 2 * 60 * 1000, // 2 minutes
  // Use this for: CONTEST, USER, VOUCHER, and other data that can be cached longer
  DEFAULT: 10 * 60 * 1000, // 10 minutes
} as const;

// Special cache times for specific use cases
export const SPECIAL_CACHE_TIME = {
  SHORT: 100, // 100ms
  LONG: 30 * 60 * 1000, // 30 minutes
} as const;
